import { IUserActivity } from '../../gql/user-activity/types';

export const UPDATE_USER_ACTIVITIES_STATE = 'UPDATE_USER_ACTIVITIES_STATE';

export interface AccountState {
  userActivities: IUserActivity[];
  userActivitiesTotal: number;
}
